import React from 'react';
import AppLink from '../routes/app_link';
import classes from './classes.module.scss';
import { isKA } from '../../../common/config/utils';

const { shared } = window;

const getMenuItemClass = (title) => {
  if (isKA()) {
    return title.active ? classes.menuItemTitleBoldActive : classes.menuItemTitleBold;
  }
  return title.active ? classes.menuItemTitleActive : classes.menuItemTitle;
};

const renderContent = (icon, title, extraNode, rightPos, onClick) => (
  <div
    data-testid={ onClick && 'clicked-menu-item' }
    className={ classes.sideMenuItemContainer }
    onClick={ onClick }
    onKeyDown={ onClick }
    suppressHydrationWarning
  >

    <div className={ classes.sideMenuItemTitleContainer } suppressHydrationWarning>
      { icon }
      <div className={ getMenuItemClass(title) } suppressHydrationWarning>
        { title.text || title }
      </div>
    </div>
    { extraNode || null }
  </div>
);

const renderInnerLink = (linkTo, icon, title, extraNode, rightPos) => (
  <AppLink
    to={ linkTo }
    className={ classes.actionLink }
    activeStyle={ { color: shared.appcolor } } // activeClassName - doesn't work
  >
    { renderContent(icon, title, extraNode, rightPos) }
  </AppLink>
);

const renderRemoteLink = (linkTo, icon, title, extraNode, rightPos, openInNewTab) => (
  openInNewTab ? (
    <a href={ linkTo } target="_blank" rel="noopener noreferrer" className={ classes.actionLink }>
      { renderContent(icon, title, extraNode, rightPos) }
    </a>
  ) : (
    <a href={ linkTo } className={ classes.actionLink }>
      { renderContent(icon, title, extraNode, rightPos) }
    </a>
  )
);

const renderActionLink = (icon, title, extraNode, rightPos, onClick) => (
  <div className={ classes.actionLink } suppressHydrationWarning>
    { renderContent(icon, title, extraNode, rightPos, onClick) }
  </div>
);

function MenuItem({
  title,
  icon,
  linkTo,
  extraNode,
  rightPos = false,
  asHref = false,
  onClick,
  openInNewTab = false
}) {
  const renderItem = () => {
    if (onClick) {
      return renderActionLink(icon, title, extraNode, rightPos, onClick);
    }
    return asHref
      ? renderRemoteLink(linkTo, icon, title, extraNode, rightPos, openInNewTab)
      : renderInnerLink(linkTo, icon, title, extraNode, rightPos);
  };
  return (<div className={ classes.sideMenuItem }>{ renderItem() }</div>);
}

export default MenuItem;
